var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import React from "react";
var SvgIconMoreOptions = function SvgIconMoreOptions(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "arrow button")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Group-Detail-\\u2013-Media-list-view-root-folder",
    transform: "translate(-424.000000, -1018.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folders",
    transform: "translate(168.000000, 654.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DSC-/-Elements-/-Buttons-/-arrow-button",
    transform: "translate(256.000000, 364.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CBD5D6",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "options",
    transform: "translate(15.000000, 7.000000)",
    fill: "#323333"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 2.5,
    cy: 10.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    cx: 2.5,
    cy: 18.5,
    r: 2.5
  })))))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMoreOptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_more_options.acf12158.svg";
export { ForwardRef as ReactComponent };